import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação do Router
import { Link } from 'react-router-dom';

class QuestionOptionsChangeStatus extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status_loading: 0,
      redirect_url: false,
      mensagem_alerta: false,
      tipo_alerta: false,
      status_alerta: false,
      question_option_id: this.props.question_option_id,
      active: this.props.active,
      correct: this.props.correct,
      class_active: '',
      alt_active: '',
      title_active: '',
      class_correct: '',
      alt_correct: '',
      title_correct: '',
    };

    this.trocarActive = this.trocarActive.bind(this);
    this.trocarCorrect = this.trocarCorrect.bind(this);
    this.deletar = this.deletar.bind(this);
  }

  componentWillReceiveProps(newProps) {
    if(typeof newProps.active !== 'undefined') {
      this.setState({
        correct: newProps.correct,
        active: newProps.active,
      });
    }
    if (newProps.active == 1) {
      this.setState({class_active: 'btn btn-sm btn-success'});
      this.setState({alt_active: 'Trocar para desativado'});
      this.setState({title_active: 'Trocar para desativado'});
    } else {
      this.setState({class_active: 'btn btn-sm btn-danger'});
      this.setState({alt_active: 'Trocar para ativado'});
      this.setState({title_active: 'Trocar para ativado'});
    }
    if (newProps.correct == 1) {
      this.setState({class_correct: 'btn btn-sm btn-success'});
      this.setState({alt_correct: 'Trocar para incorreto'});
      this.setState({title_correct: 'Trocar para incorreto'});
    } else {
      this.setState({class_correct: 'btn btn-sm btn-warning'});
      this.setState({alt_correct: 'Trocar para correto'});
      this.setState({title_correct: 'Trocar para correto'});
    }
  }

  componentDidMount() {
    if (this.state.active == 1) {
      this.setState({class_active: 'btn btn-sm btn-success'});
      this.setState({alt_active: 'Trocar para desativado'});
      this.setState({title_active: 'Trocar para desativado'});
    } else {
      this.setState({class_active: 'btn btn-sm btn-danger'});
      this.setState({alt_active: 'Trocar para ativado'});
      this.setState({title_active: 'Trocar para ativado'});
    }
    if (this.state.correct == 1) {
      this.setState({class_correct: 'btn btn-sm btn-success'});
      this.setState({alt_correct: 'Trocar para incorreto'});
      this.setState({title_correct: 'Trocar para incorreto'});
    } else {
      this.setState({class_correct: 'btn btn-sm btn-warning'});
      this.setState({alt_correct: 'Trocar para correto'});
      this.setState({title_correct: 'Trocar para correto'});
    }
  }
  deletar (event) {
    var question_option_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar essa opção?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/questao/opcao/' + question_option_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.deletarLinha(question_option_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  trocarActive () {
    var toggle = this.state.active;
    if (toggle === 1) {
      toggle = 0;
    } else {
      toggle = 1;
    }
    var datasave = {
      id: this.state.question_option_id,
      active: toggle,
    };
    var confirmacao = window.confirm('Tem certeza que deseja mudar o status dessa opção?');
    if(confirmacao) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/questao/opcao/change_active', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            if (toggle === 1) {
              self.setState({class_active: 'btn btn-sm btn-success'});
              self.setState({alt_active: 'Trocar para desativado'});
              self.setState({title_active: 'Trocar para desativado'});
              self.setState({active: toggle});
            } else {
              self.setState({class_active: 'btn btn-sm btn-danger'});
              self.setState({alt_active: 'Trocar para ativado'});
              self.setState({title_active: 'Trocar para ativado'});
              self.setState({active: toggle});
            }
            self.props.trocarActive(responseJson.data);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  trocarCorrect () {
    var toggle = this.state.correct;
    if (toggle === 1) {
      toggle = 0;
    } else {
      toggle = 1;
    }
    var datasave = {
      id: this.state.question_option_id,
      correct: toggle,
    };
    var confirmacao = window.confirm('Tem certeza que deseja mudar o status dessa opção?');
    if(confirmacao) {
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/questao/opcao/change_correct', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.refreshTable(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  render() {
    return (
<div className='btn-group'>
  <RequestApi ref={'request_api'} />
  <button onClick={this.trocarCorrect} disabled={this.state.correct === 1 || this.state.active === 0 ? "disabled" : ""} className={this.state.class_correct} alt={this.state.alt_correct} title={this.state.title_correct}><i className="fa fa-fw fa-user"></i></button>
  <button onClick={this.trocarActive} disabled={this.state.correct === 1 ? "disabled" : ""} className={this.state.class_active} alt={this.state.alt_active} title={this.state.title_active}><i className="fa fa-fw fa-power-off"></i></button>
  <button className="btn btn-sm btn-danger" disabled={this.state.correct === 1 ? "disabled" : ""} value={this.state.question_option_id} onClick={this.deletar}>
    <i className="fa fa-fw fa-trash"></i>
  </button>
</div>
    );
  }
}

export default QuestionOptionsChangeStatus;



// WEBPACK FOOTER //
// ./src/Components/Questions/Elements/QuestionOptionsChangeStatus.js